import { action } from 'typesafe-actions'
import { MyCourseActionTypes } from './types'
import { IUserCourse } from '../interface'


export const fetchRequest = (searchParams:any) => {
   //console.log("fetchRequest: " + searchParams.searchTerm);
   return action(MyCourseActionTypes.FETCH_REQUEST, searchParams);
}

export const fetchSuccess = (data: IUserCourse[]) => action(MyCourseActionTypes.FETCH_SUCCESS, data)

export const selectCourse = (id: string) => action(MyCourseActionTypes.SELECT, id)
export const courseSelected = (data: IUserCourse) => action(MyCourseActionTypes.SELECTED, data)
export const fetchError = (message: string) => action(MyCourseActionTypes.FETCH_ERROR, message)

export const addRequest = (data: IUserCourse) => action(MyCourseActionTypes.ADD, data)
export const addSuccess = (data: IUserCourse) => action(MyCourseActionTypes.ADD_SUCCESS, data)
export const addError = (message: string) => action(MyCourseActionTypes.ADD_ERROR, message)
export const addClear = () => action(MyCourseActionTypes.ADD_CLEAR)

export const editRequest = (keyValues: any) => action(MyCourseActionTypes.EDIT, keyValues)
export const editSuccess = (message: string) => action(MyCourseActionTypes.EDIT_SUCCESS, message)
export const editError = (message: string) => action(MyCourseActionTypes.EDIT_ERROR, message)

//export const askTrainerRequest = (doc: any) => action(MyCourseActionTypes.ASKTRAINER, doc)
export const askTrainerRequest = (doc:any) => {
   //console.log("fetchRequest: " + searchParams.searchTerm);
   return action(MyCourseActionTypes.ASKTRAINER, doc);
}
export const askTrainerSuccess = (message: string) => action(MyCourseActionTypes.ASKTRAINER_SUCCESS, message)
export const askTrainerError = (message: string) => action(MyCourseActionTypes.ASKTRAINER_ERROR, message)

export const notified = () => action(MyCourseActionTypes.NOTIFIED)